module.exports = __webpack_public_path__ + "img/21_39.cdfe752d.png";